export const possibleTypes = {
  Product: [
    'DerivativeScriptureProduct',
    'DirectScriptureProduct',
    'OtherProduct',
    '.+Product'],
  Engagement: [
    'InternshipEngagement',
    'LanguageEngagement',
    '.+Engagement'],
  Project: [
    'InternshipProject',
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
    '.+Project'],
  Secured: [
    'CommentList',
    'CommentThreadList',
    'ProgressReportList',
    'PromptVariantResponseList',
    'SecuredAIAssistedTranslation',
    'SecuredActor',
    'SecuredBoolean',
    'SecuredBooleanNullable',
    'SecuredBudget',
    'SecuredCeremony',
    'SecuredDate',
    'SecuredDateNullable',
    'SecuredDateRange',
    'SecuredDateTime',
    'SecuredDateTimeNullable',
    'SecuredDegree',
    'SecuredDirectory',
    'SecuredEducationList',
    'SecuredEngagementList',
    'SecuredEngagementStatus',
    'SecuredFieldRegion',
    'SecuredFieldRegions',
    'SecuredFieldZone',
    'SecuredFile',
    'SecuredFileVersion',
    'SecuredFinanceDepartmentIdBlockNullable',
    'SecuredFinancialReportingType',
    'SecuredFinancialReportingTypes',
    'SecuredFirstScripture',
    'SecuredFloat',
    'SecuredFloatNullable',
    'SecuredFundingAccount',
    'SecuredGenderNullable',
    'SecuredInt',
    'SecuredIntNullable',
    'SecuredInternPosition',
    'SecuredInternshipEngagementList',
    'SecuredLanguage',
    'SecuredLanguageEngagementList',
    'SecuredLanguageList',
    'SecuredLanguageMilestone',
    'SecuredLanguageNullable',
    'SecuredLanguages',
    'SecuredLocation',
    'SecuredLocationList',
    'SecuredLocationType',
    'SecuredLocations',
    'SecuredMethodologies',
    'SecuredMethodology',
    'SecuredOrganization',
    'SecuredOrganizationList',
    'SecuredOrganizationReach',
    'SecuredOrganizationTypes',
    'SecuredPartner',
    'SecuredPartnerList',
    'SecuredPartnerTypes',
    'SecuredPartnership',
    'SecuredPartnershipAgreementStatus',
    'SecuredPartnershipList',
    'SecuredPartnershipsProducingMediums',
    'SecuredPeriodicReport',
    'SecuredPeriodicReportList',
    'SecuredPostList',
    'SecuredProducible',
    'SecuredProductList',
    'SecuredProductMediums',
    'SecuredProductPurposes',
    'SecuredProductSteps',
    'SecuredProgressMeasurement',
    'SecuredProgressReport',
    'SecuredProgressReportStatus',
    'SecuredProjectChangeRequestList',
    'SecuredProjectChangeRequestStatus',
    'SecuredProjectChangeRequestTypes',
    'SecuredProjectList',
    'SecuredProjectMemberList',
    'SecuredProjectStep',
    'SecuredProjectTypes',
    'SecuredPrompt',
    'SecuredReportPeriod',
    'SecuredRichText',
    'SecuredRichTextNullable',
    'SecuredRoles',
    'SecuredScriptureRanges',
    'SecuredScriptureRangesOverride',
    'SecuredString',
    'SecuredStringList',
    'SecuredStringNullable',
    'SecuredTags',
    'SecuredTimeZone',
    'SecuredToolKey',
    'SecuredToolUsageList',
    'SecuredTranslationProjectList',
    'SecuredUnavailabilityList',
    'SecuredUnspecifiedScripturePortion',
    'SecuredUser',
    'SecuredUserList',
    'SecuredUserStatus',
    'Secured.+'],
  PaginatedList: [
    'CommentList',
    'CommentThreadList',
    'EducationListOutput',
    'EngagementListOutput',
    'EthnoArtListOutput',
    'FieldRegionListOutput',
    'FieldZoneListOutput',
    'FileListOutput',
    'FilmListOutput',
    'FundingAccountListOutput',
    'InternshipEngagementListOutput',
    'InternshipProjectListOutput',
    'LanguageEngagementListOutput',
    'LanguageListOutput',
    'LocationListOutput',
    'NotificationList',
    'OrganizationListOutput',
    'PartnerListOutput',
    'PartnershipListOutput',
    'PeriodicReportListOutput',
    'ProductCompletionDescriptionSuggestionsOutput',
    'ProductListOutput',
    'ProgressReportList',
    'ProgressReportMediaList',
    'ProjectListOutput',
    'PromptVariantResponseList',
    'ResourceMutationList',
    'SecuredEducationList',
    'SecuredEngagementList',
    'SecuredInternshipEngagementList',
    'SecuredLanguageEngagementList',
    'SecuredLanguageList',
    'SecuredLocationList',
    'SecuredOrganizationList',
    'SecuredPartnerList',
    'SecuredPartnershipList',
    'SecuredPartnershipsProducingMediums',
    'SecuredPeriodicReportList',
    'SecuredPostList',
    'SecuredProductList',
    'SecuredProjectChangeRequestList',
    'SecuredProjectList',
    'SecuredProjectMemberList',
    'SecuredToolUsageList',
    'SecuredTranslationProjectList',
    'SecuredUnavailabilityList',
    'SecuredUserList',
    'StoryListOutput',
    'ToolListOutput',
    'TranslationProjectListOutput',
    'UnavailabilityListOutput',
    'UserListOutput',
    'WebhookList',
    '.+ListOutput', 'Secured.+List'],
  Actor: [
    'SystemAgent',
    'User',
  ],
  CeremonyMutation: [
    'CeremonyCreated',
    'CeremonyUpdated',
  ],
  CeremonyMutationOrDeletion: [
    'CeremonyCreated',
    'CeremonyDeleted',
    'CeremonyUpdated',
  ],
  Changeset: [
    'ProjectChangeRequest',
  ],
  ChangesetAware: [
    'Budget',
    'BudgetRecord',
    'InternshipEngagement',
    'InternshipProject',
    'LanguageEngagement',
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
    'Partnership',
  ],
  Commentable: [
    'InternshipEngagement',
    'InternshipProject',
    'Language',
    'LanguageEngagement',
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
    'Partner',
    'ProgressReport',
    'User',
  ],
  DerivativeScriptureProductMutation: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductUpdated',
  ],
  DirectScriptureProductMutation: [
    'DirectScriptureProductCreated',
    'DirectScriptureProductUpdated',
  ],
  EngagementCreated: [
    'InternshipEngagementCreated',
    'LanguageEngagementCreated',
  ],
  EngagementDeleted: [
    'InternshipEngagementDeleted',
    'LanguageEngagementDeleted',
  ],
  EngagementMutation: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductDeleted',
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductCreated',
    'DirectScriptureProductDeleted',
    'DirectScriptureProductUpdated',
    'InternshipEngagementCreated',
    'InternshipEngagementUpdated',
    'LanguageEngagementCreated',
    'LanguageEngagementUpdated',
    'OtherProductCreated',
    'OtherProductDeleted',
    'OtherProductUpdated',
  ],
  EngagementMutationOrDeletion: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductDeleted',
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductCreated',
    'DirectScriptureProductDeleted',
    'DirectScriptureProductUpdated',
    'InternshipEngagementCreated',
    'InternshipEngagementDeleted',
    'InternshipEngagementUpdated',
    'LanguageEngagementCreated',
    'LanguageEngagementDeleted',
    'LanguageEngagementUpdated',
    'OtherProductCreated',
    'OtherProductDeleted',
    'OtherProductUpdated',
  ],
  EngagementUpdate: [
    'InternshipEngagementUpdate',
    'LanguageEngagementUpdate',
  ],
  EngagementUpdated: [
    'InternshipEngagementUpdated',
    'LanguageEngagementUpdated',
  ],
  FileNode: [
    'Directory',
    'File',
    'FileVersion',
  ],
  FirstScripture: [
    'ExternalFirstScripture',
    'InternalFirstScripture',
    'NoFirstScripture',
  ],
  InternshipEngagementMutation: [
    'InternshipEngagementCreated',
    'InternshipEngagementUpdated',
  ],
  LanguageEngagementMutation: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductDeleted',
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductCreated',
    'DirectScriptureProductDeleted',
    'DirectScriptureProductUpdated',
    'LanguageEngagementCreated',
    'LanguageEngagementUpdated',
    'OtherProductCreated',
    'OtherProductDeleted',
    'OtherProductUpdated',
  ],
  LanguageMutation: [
    'LanguageCreated',
    'LanguageUpdated',
  ],
  LanguageMutationOrDeletion: [
    'LanguageCreated',
    'LanguageDeleted',
    'LanguageUpdated',
  ],
  Media: [
    'Audio',
    'Image',
    'Video',
  ],
  Notification: [
    'CommentViaMentionNotification',
    'SystemNotification',
  ],
  OtherProductMutation: [
    'OtherProductCreated',
    'OtherProductUpdated',
  ],
  PeriodicReport: [
    'FinancialReport',
    'NarrativeReport',
    'ProgressReport',
  ],
  Pinnable: [
    'InternshipProject',
    'Language',
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
    'Partner',
    'User',
  ],
  PnpExtractionResult: [
    'PnpPlanningExtractionResult',
    'PnpProgressExtractionResult',
  ],
  Postable: [
    'InternshipProject',
    'Language',
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
    'Partner',
  ],
  Producible: [
    'DerivativeScriptureProduct',
    'DirectScriptureProduct',
    'EthnoArt',
    'Film',
    'OtherProduct',
    'Story',
  ],
  ProductCreated: [
    'DerivativeScriptureProductCreated',
    'DirectScriptureProductCreated',
    'OtherProductCreated',
  ],
  ProductDeleted: [
    'DerivativeScriptureProductDeleted',
    'DirectScriptureProductDeleted',
    'OtherProductDeleted',
  ],
  ProductMutation: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductCreated',
    'DirectScriptureProductUpdated',
    'OtherProductCreated',
    'OtherProductUpdated',
  ],
  ProductMutationOrDeletion: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductDeleted',
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductCreated',
    'DirectScriptureProductDeleted',
    'DirectScriptureProductUpdated',
    'OtherProductCreated',
    'OtherProductDeleted',
    'OtherProductUpdated',
  ],
  ProductUpdate: [
    'DerivativeScriptureProductUpdate',
    'DirectScriptureProductUpdate',
    'OtherProductUpdate',
  ],
  ProductUpdated: [
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductUpdated',
    'OtherProductUpdated',
  ],
  ProjectMemberMutation: [
    'ProjectMemberCreated',
    'ProjectMemberUpdated',
  ],
  ProjectMemberMutationOrDeletion: [
    'ProjectMemberCreated',
    'ProjectMemberDeleted',
    'ProjectMemberUpdated',
  ],
  ProjectMutation: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductDeleted',
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductCreated',
    'DirectScriptureProductDeleted',
    'DirectScriptureProductUpdated',
    'InternshipEngagementCreated',
    'InternshipEngagementDeleted',
    'InternshipEngagementUpdated',
    'LanguageEngagementCreated',
    'LanguageEngagementDeleted',
    'LanguageEngagementUpdated',
    'OtherProductCreated',
    'OtherProductDeleted',
    'OtherProductUpdated',
    'ProjectCreated',
    'ProjectTransitioned',
    'ProjectUpdated',
  ],
  ProjectMutationOrDeletion: [
    'DerivativeScriptureProductCreated',
    'DerivativeScriptureProductDeleted',
    'DerivativeScriptureProductUpdated',
    'DirectScriptureProductCreated',
    'DirectScriptureProductDeleted',
    'DirectScriptureProductUpdated',
    'InternshipEngagementCreated',
    'InternshipEngagementDeleted',
    'InternshipEngagementUpdated',
    'LanguageEngagementCreated',
    'LanguageEngagementDeleted',
    'LanguageEngagementUpdated',
    'OtherProductCreated',
    'OtherProductDeleted',
    'OtherProductUpdated',
    'ProjectCreated',
    'ProjectDeleted',
    'ProjectMemberCreated',
    'ProjectMemberDeleted',
    'ProjectMemberUpdated',
    'ProjectTransitioned',
    'ProjectUpdated',
  ],
  Resource: [
    'Budget',
    'BudgetRecord',
    'Ceremony',
    'Comment',
    'CommentThread',
    'CommentViaMentionNotification',
    'DerivativeScriptureProduct',
    'DirectScriptureProduct',
    'Directory',
    'Education',
    'EthnoArt',
    'FieldRegion',
    'FieldZone',
    'File',
    'FileVersion',
    'Film',
    'FinancialReport',
    'FundingAccount',
    'InternshipEngagement',
    'InternshipProject',
    'Language',
    'LanguageEngagement',
    'Location',
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
    'NarrativeReport',
    'Organization',
    'OtherProduct',
    'Partner',
    'Partnership',
    'Post',
    'ProgressReport',
    'ProjectChangeRequest',
    'ProjectMember',
    'Story',
    'SystemNotification',
    'Tool',
    'ToolUsage',
    'Unavailability',
    'User',
  ],
  SearchResult: [
    'DerivativeScriptureProduct',
    'DirectScriptureProduct',
    'EthnoArt',
    'FieldRegion',
    'FieldZone',
    'Film',
    'FinancialReport',
    'FundingAccount',
    'InternshipProject',
    'Language',
    'Location',
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
    'NarrativeReport',
    'Organization',
    'OtherProduct',
    'Partner',
    'ProgressReport',
    'Story',
    'Tool',
    'User',
  ],
  TemporalMedia: [
    'Audio',
    'Video',
  ],
  TranslationProject: [
    'MomentumTranslationProject',
    'MultiplicationTranslationProject',
  ],
  UserMutation: [
    'UserCreated',
    'UserUpdated',
  ],
  UserMutationOrDeletion: [
    'UserCreated',
    'UserDeleted',
    'UserUpdated',
  ],
  VisualMedia: [
    'Image',
    'Video',
  ],
  WorkflowTransitionTo: [
    'WorkflowTransitionDynamicTo',
    'WorkflowTransitionStaticTo',
  ],
} as const;
